import { Button, Form, Input, Select, Space } from "antd";
import { useEffect, useState } from "react";
import ProductApi from "../../../../api/ProductApi";
import GatewayApi from "../../../../api/GatewayApi";
import MapPicker from "../../../../components/ui-components/map-picker/MapPicker";
import { CreateGatewayTemplateWizardWrapper, FormRow, FormWrapper, MapPickerWrapper, OperationWrapper, Title, TitleWrapper } from "./CreateGatewayWizard.styled";

interface CreateGatewayWizardProps {
    onClose: ()=> void,
    onComplete: ()=> void,
}

export const CreateGatewayWizard: React.FC<CreateGatewayWizardProps> = (props)=> {
    // api
    let gatewayApi = new GatewayApi();
    let productApi = new ProductApi();
    const [form] = Form.useForm();

    // state
    let [submitEnabled, setSubmitEnabled] = useState(false);
    let [createGatewayParams, setCreateGatewayParams] = useState({} as any);

    // validate
    let validateForm = ()=> {
        form.setFieldsValue(createGatewayParams);
        setCreateGatewayParams({...createGatewayParams})
        form.validateFields().then((values)=> {
            setSubmitEnabled(true);
        }).catch((err)=> {
            console.log(err);
        });
    }

    // events
    
    let onGatewaySnChange = (e)=> {
        createGatewayParams.nodeSn = e.target.value;
        validateForm();
    };

    let onGatewayNameChange = (e)=> {
        createGatewayParams.name = e.target.value;
        validateForm();
    };

    let onGatewayNoChange = (e)=> {
        createGatewayParams.gatewayNo = e.target.value;
        validateForm();
    };

    let onPositionMethodChange = (value)=> {
        createGatewayParams.positioningMethod = value;
        validateForm();
    };

    let onPick = (lng, lat)=> {
        createGatewayParams.geoLatitude = lat;
        createGatewayParams.geoLongitude = lng;
        validateForm();
    };

    let onRemarksChange = (e)=> {
        createGatewayParams.remarks = e.target.value;
        validateForm();
    };

    let onSubmit = async (e)=> {
        if (createGatewayParams.id) {
            await gatewayApi.update(createGatewayParams);
        } else {
            await gatewayApi.create(createGatewayParams);
        }
        props.onComplete();
        props.onClose();
    };

    let onCancel = (e)=> {
        props.onClose();
    };

    let positionMethodOptions = [
        {
            label: '自动定位',
            value: 'AUTO',
        }, {
            label: '手动定位',
            value: 'MANUAL',
        },
    ];

    // render
    return (
        <CreateGatewayTemplateWizardWrapper>
            <TitleWrapper>
                <Title>新增网关</Title>
            </TitleWrapper>

            <FormWrapper>
                <Form form={form} name="form" layout="vertical">
                    <Form.Item name="nodeSn" label="网关序列号SN" rules={[{required: true}]} initialValue={createGatewayParams.sn}>
                        <Input onChange={onGatewaySnChange} />
                    </Form.Item>

                    <Form.Item name="name" label="网关名称" rules={[{required: true}]} initialValue={createGatewayParams.name}>
                        <Input onChange={onGatewayNameChange} />
                    </Form.Item>

                    <Form.Item name="gatewayNo" label="网关编号" rules={[{required: true}]} initialValue={createGatewayParams.no}>
                        <Input onChange={onGatewayNoChange} />
                    </Form.Item>

                    <FormRow>
                        <Form.Item name="positioningMethod" label="定位方式" rules={[{required: true}]} initialValue={'AUTO'} style={{flex: '1 1 50%'}}>
                            <Select
                                placeholder="请选择定位方式"
                                onChange={onPositionMethodChange}
                                options={positionMethodOptions}
                            />
                        </Form.Item>

                        {createGatewayParams.positioningMethod === 'MANUAL' &&
                            <Form.Item name="geoLongitude" label="经度" rules={[{required: true}]} style={{flex: '0.5 0.5 25%'}}>
                                <Input disabled={true} value={createGatewayParams.geoLongitude}/>
                            </Form.Item>
                        }
                        {createGatewayParams.positioningMethod === 'MANUAL' &&
                            <Form.Item name="geoLatitude" label="纬度" rules={[{required: true}]} style={{flex: '0.5 0.5 25%'}}>
                                <Input disabled={true} value={createGatewayParams.geoLatitude}/>
                            </Form.Item>
                        }
                    </FormRow>

                    { createGatewayParams.positioningMethod === 'MANUAL' && <FormRow>
                        <MapPickerWrapper>
                            <MapPicker lng={createGatewayParams.geoLongitude} lat={createGatewayParams.geoLatitude} onPick={onPick} />
                        </MapPickerWrapper>
                    </FormRow>
                    }
            
                    <Form.Item name="remarks" label="备注" rules={[{required: false}]} initialValue={createGatewayParams.remarks}>
                        <Input.TextArea style={{height: '50px'}} onChange={onRemarksChange}/>
                    </Form.Item>
                </Form>
            </FormWrapper>

            <OperationWrapper>
                <Space size="middle">
                    <Button type="primary" disabled={!submitEnabled} onClick={onSubmit}>确定</Button>
                    <Button type="primary" danger onClick={onCancel}>取消</Button>
                </Space>
            </OperationWrapper>
        </CreateGatewayTemplateWizardWrapper>
    )
}
